import './sections/blocks/main.ts';
import * as Feed          from '../../../components/sections/feed/main';
import * as Maps          from '../../../components/blocks/map/main';
import * as DirectContact from '../../../components/blocks/direct-contact/main';

// Partner feeds
const feeds = Array.from(document.querySelectorAll('.feed')) as HTMLElement[];
feeds.forEach(feed => Feed.init(feed));

Maps.init();
DirectContact.init();
